import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Campus } from '@uc/web/shared/data-models';
import { UniversityReadUrlService } from '@uc/web/core';
import { Observable, tap } from 'rxjs';

import { fetchCampusesList } from './data-access/+state/campus-locations.actions';
import { getStateCampusLocations } from './data-access/+state/campus-locations.selectors';
import { AsyncPipe } from '@angular/common';
import { CampusCardNavigationComponent } from './components/campus-card-navigation/campus-card-navigation.component';
import { UniversitySectionCardComponent } from '../../components/university-section-card/university-section-card.component';

@Component({
	selector: 'uc-campus-locations',
	templateUrl: './campus-locations.component.html',
	imports: [AsyncPipe, CampusCardNavigationComponent, UniversitySectionCardComponent],
	providers: [UniversityReadUrlService],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampusLocationsComponent implements OnInit {
	uniId = input<number | null>(null);
	uniName = input.required<string>();
	ugSearchOrderPosition = input<number | null>(null);
	campus$!: Observable<Campus | null>;
	product = this._readUrlSrv.getProduct();
	navigationItems: string[] = [];
	selectedIndex = 0;

	constructor(
		private _store: Store,
		private _route: ActivatedRoute,
		private _readUrlSrv: UniversityReadUrlService,
	) {}

	ngOnInit(): void {
		const universityUrl = this._route.parent?.snapshot.params['uniName'];
		this._store.dispatch(
			fetchCampusesList({
				universityUrl: universityUrl,
			}),
		);

		this.campus$ = this._store.pipe(
			select(getStateCampusLocations),
			tap((campus) =>
				campus?.locations?.forEach((campus) =>
					this.navigationItems.push(campus.name),
				),
			),
		);
	}

	onSelectIndex(index: number): void {
		this.selectedIndex = index;
	}
}
